import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';

import UploadDocument from 'modules/documents/components/UploadDocument';

type Props = {
  encumbranceFile: File | undefined;
  inputLabel: string;
  // eslint-disable-next-line no-unused-vars
  handleChangeEncumbranceFile: (file: File) => void;
};

const ShareEncumbranceViewFormScriptureData: FC<Props> = ({
  encumbranceFile,
  inputLabel,
  handleChangeEncumbranceFile,
}) => {
  const { t } = useTranslate();

  return (
    <>
      <div className="pb-0">
        <UploadDocument
          label="Scripture"
          inputLabel={t(inputLabel) || inputLabel}
          file={encumbranceFile}
          setFile={handleChangeEncumbranceFile}
        />
      </div>
    </>
  );
};

export default ShareEncumbranceViewFormScriptureData;
